<div class="dept-select">
  <span v-if="$slots.default" @click.stop="showModal">
    <slot></slot>
  </span>
  <div v-else class="user-select">
    <div class="user-content" :class="isError ? 'is-error': ''">
      <div class="user-list">
        <span v-if="!selectedDepts.length">请选择</span>
        <template v-else>
          <a-tag
            v-for="user in selectedDepts"
            :key="user.id"
            closable
            color="blue"
            @close.prevent="deleteSelectedDept(user.id)"
          >
            <span class="ellipsis">{{
              user.name?.length > 20 ? user.name?.slice(0, 15) + "..." : user.name
            }}</span>
          </a-tag>
        </template>
      </div>
      <div
        class="add-icon"
        v-if="maxCount === 0 || selectedDepts.length < maxCount"
        type="link"
        @click="showModal"
      >
        <img src="../../assets/images/icon_add.png" />
      </div>
    </div>
    <!--    <template v-if="showDeptList">-->
    <!--      <a-tag-->
    <!--        v-for="user in selectedDepts"-->
    <!--        :key="user.id"-->
    <!--        closable-->
    <!--        color="blue"-->
    <!--        @close.prevent="deleteSelectedDept(user.id)"-->
    <!--      >-->
    <!--        {{ user.name }}-->
    <!--      </a-tag>-->
    <!--    </template>-->

    <!--    <span v-if="$slots.default" @click="showModal">-->
    <!--      <slot></slot>-->
    <!--    </span>-->
    <!--    <template v-else>-->
    <!--      <a-button-->
    <!--        v-if="maxCount === 0 || selectedDepts.length < maxCount"-->
    <!--        style="padding: 0"-->
    <!--        type="link"-->
    <!--        @click="showModal"-->
    <!--      >-->
    <!--        <ant-icon type="PlusCircleOutlined"></ant-icon>-->
    <!--        <span>添加</span>-->
    <!--      </a-button>-->
    <!--    </template>-->
  </div>
  <a-modal
    v-model:visible="visible"
    :centered="true"
    :keyboard="false"
    :mask-closable="false"
    class="dept-select-modal"
    width="520px"
    @cancel="closeModal"
    @ok="ok"
  >
    <template #title>
      <span>选择部门</span>
      <!-- <small>可导出指定部门的员工信息</small> -->
    </template>
    <div class="dept-select-modal__bd">
      <div class="user-select__left">
        <div class="user-select__left__hd">
          <department-tree-select
            v-model:value="userSearchId"
            class="w100"
            placeholder="输入部门名称关键字"
            @select="onDeptTreeSelect"
          ></department-tree-select>
        </div>
        <div class="user-select__left__bd">
          <a-tree
            :expandedKeys="expandedKeys"
            :fieldNames="{ children: 'children', title: 'name', key: 'id' }"
            :tree-data="treeData"
            show-icon
            @select="addTempDept"
          >
            <template #department>
              <ant-icon type="ForkOutlined"></ant-icon>
            </template>
          </a-tree>
        </div>
      </div>
      <div class="user-select__right">
        <div class="user-select__right__hd">
          <span class="text-grey">已选择的部门（{{ tempDepts.length }}个）</span>
        </div>
        <div class="user-select__right__bd">
          <div v-for="item in tempDepts" :key="item.id" class="selected-user">
            <div class="selected-user__icon">
              <ant-icon type="DeptOutlined"></ant-icon>
            </div>
            <span>{{ item.name }}</span>
            <div class="selected-user__delete" @click="deleteTempDept(item.id)">
              <ant-icon type="CloseCircleOutlined"></ant-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</div>
